// @flow

export type NuxStep =
  | 'welcome'
  | 'gender'
  | 'locale'
  | 'country'
  | 'extension'
  | 'topic'
  | 'loader';

/**
 * Dispatch action to current NUX step
 * @param {NuxStep} step The current step in NUX
 */
export type SetNuxProgress = {
  type: 'SET_NUX_PROGRESS',
  payload: {
    step: NuxStep,
  },
};

export default function setNuxProgress(step: NuxStep): SetNuxProgress {
  return {
    type: 'SET_NUX_PROGRESS',
    payload: { step },
  };
}
